import { useMemo } from "react";
import { gql, useKraxiQuery } from "@origin-digital/kraxi";
import { krakenClient } from "./queries";
import { JointAccountHolderEligibility } from "./graphql-types/JointAccountHolderEligibility";
import { determineJointAccountHolderEligibility } from "./jointAccountHolderEligibility";

export const jointAccountHolderEligibilityQuery = gql`
  query JointAccountHolderEligibility {
    viewer {
      hasFamilyIssues
      accountUserRoles {
        account {
          number
        }
        role
      }
      portfolioUserRoles {
        portfolio {
          number
        }
        role
      }
      accounts {
        number
        status
        accountType
        portfolio {
          number
        }
        activeHardshipAgreements {
          __typename
        }
        ... on AccountType {
          properties {
            address
          }
          agreements(active: true) {
            supplyType
          }
        }
      }
    }
  }
`;

export const useJointAccountHolderEligibility = (enabled: boolean) => {
  const { data, loading, error } = useKraxiQuery<JointAccountHolderEligibility>(
    jointAccountHolderEligibilityQuery,
    {
      client: krakenClient,
      skip: !enabled,
      fetchPolicy: "network-only",
      errorPolicy: "none",
      notifyOnNetworkStatusChange: true,
    }
  );

  const access = useMemo(
    () =>
      determineJointAccountHolderEligibility(
        enabled && !loading && !error ? data : undefined
      ),
    [enabled, loading, error, data]
  );
  return {
    ...access,
    loading: enabled && loading,
    error,
  };
};
